import { joinParts } from './joinParts';

type TRequirementLimitField = (typeof LIMIT_TEXTS)[number][0];

type TRequirementLimits = Partial<Record<TRequirementLimitField, number | null>>;

type TSortableRequirement = TRequirementLimits & Readonly<{
  id: string
  group?: number | null
  label?: unknown
  date_created?: string | null
}>;

/* The order is both the display order and the sort rank in getKindRank. */
const LIMIT_TEXTS = [
  ['minimum_duration', (value) => `Mindestaufenthalt: ${value} M.`],
  ['maximum_duration', (value) => `Maximalaufenthalt: ${value} M.`],
  ['maximum_stays', (value) => `Maximale Aufenthalte: ${value}`],
  ['minimum_percentage', (value) => `Arbeitsmodell: ${value}%`],
] as const satisfies ReadonlyArray<readonly [string, (value: number) => string]>;

export const getRequirementLimitText = (requirement: TRequirementLimits): string =>
  joinParts(
    LIMIT_TEXTS.map(([field, format]) => {
      const value = requirement[field];
      return value ? format(value) : null;
    }),
    ', ',
  );

const getKindRank = (requirement: TSortableRequirement): number =>
  (requirement.label
    ? 0
    : LIMIT_TEXTS.findIndex(([field]) => requirement[field]) + 1);

/* The database gives no order within a group that puts a minimum before a maximum. */
export const sortRequirements = <T extends TSortableRequirement>(
  requirements: ReadonlyArray<T>,
): T[] =>
  [...requirements].sort((a, b) =>
    (a.group ?? 0) - (b.group ?? 0)
    || getKindRank(a) - getKindRank(b)
    || (a.date_created ?? '').localeCompare(b.date_created ?? '')
    || a.id.localeCompare(b.id));
